export default __webpack_public_path__ + "static/media/facebook-24.d531a8b8.svg";